"use client"

import { useState } from "react"
import { CalendarIcon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { FormItem, FormLabel, FormDescription, FormMessage, FormField } from "@/components/ui/form"
import type { FormElement } from "./types"
import type { UseFormReturn } from "react-hook-form"

interface FormDatepickerProps {
  element: FormElement
  form: UseFormReturn<any>
}

export function FormDatepicker({ element, form }: FormDatepickerProps) {
  const [open, setOpen] = useState(false)

  return (
    <FormField
      control={form.control}
      name={element.name!}
      rules={{
        required: element.validation?.required ? `${element.ui?.label || element.name} is required` : false,
      }}
      render={({ field }) => {
        const date = field.value ? new Date(field.value) : undefined

        return (
          <FormItem>
            {element.ui?.label && <FormLabel>{element.ui.label}</FormLabel>}
            <Popover open={open} onOpenChange={setOpen}>
              <PopoverTrigger asChild>
                <Button variant="outline" className="w-full justify-between font-normal bg-transparent">
                  {date ? date.toLocaleDateString() : element.ui?.placeholder || "Select date"}
                  <CalendarIcon className="h-4 w-4 opacity-50" />
                </Button>
              </PopoverTrigger>
              <PopoverContent className="w-auto overflow-hidden p-0" align="start">
                <Calendar
                  mode="single"
                  selected={date}
                  captionLayout="dropdown"
                  onSelect={(newDate) => {
                    field.onChange(newDate?.toISOString())
                    setOpen(false)
                  }}
                />
              </PopoverContent>
            </Popover>
            {element.ui?.hint && <FormDescription>{element.ui.hint}</FormDescription>}
            <FormMessage />
          </FormItem>
        )
      }}
    />
  )
}

